import { API } from "@reward-plugin/api/v1";

export const APP_BASEPATH: string = process.env.NEXT_PUBLIC_APP_BASEURL;

export const api = new API(process.env.NEXT_PUBLIC_API_BASEURL);

export * from "@reward-plugin/api/v1";
